import {calculateReportPercentage} from './calculateReportPercentage';
import {calculateReportShares} from './calculateReportShares';

interface ReportRevenue {
  labourRevenue: number;
  materialRevenue: number;
  dmmRevenue?: number;
  totalRevenue: number;
}

export function calculateReportRevenuePercentages(revenue: ReportRevenue | undefined) {
  const [labour, material, dmm] = calculateReportShares(
    [revenue?.labourRevenue, revenue?.materialRevenue, revenue ? (revenue.dmmRevenue ?? 0) : null],
    revenue?.totalRevenue ?? null
  );
  return {
    labour: labour ?? null,
    material: material ?? null,
    dmm: dmm ?? null,
    total: calculateReportPercentage(revenue?.totalRevenue, revenue?.totalRevenue),
  };
}
